import React, { Component } from 'react'
import { firebaseRef } from 'config'
import Firebase from 'firebase'
import FeatureBoard from 'components/featureboard/FeatureBoard'
import ForumNameNotifier from 'components/ForumNameNotifier'
import RequestFeatureModal from 'components/featureboard/RequestFeatureModal'
import 'css/featureboard.less'

export default class FeatureBoardContainer extends Component {
  constructor(props) {
    super(props)
    this.featureAdded = this.featureAdded.bind(this)
    this.featureChanged = this.featureChanged.bind(this)
    this.state = {
      features: [],
      showModal: false
    }
  }

  componentDidMount() {
    window.analytics.page('Featureboard')
    const ref = firebaseRef.child('featureboard')
    ref.on('child_added', this.featureAdded)
    ref.on('child_changed', this.featureChanged)
  }

  componentWillUnmount() {
    const ref = firebaseRef.child('featureboard')
    ref.off('child_added', this.featureAdded)
    ref.off('child_changed', this.featureChanged)
  }

  featureAdded(snap) {
    let feature = snap.val()
    feature.votes = feature.votes || {}
    this.setState({
      features: [...this.state.features, feature]
    })
  }

  featureChanged(snap) {
    let feature = snap.val()
    feature.votes = feature.votes || {}
    this.setState({
      features: this.state.features.map(f => f._id === feature._id ? feature : f)
    })
  }

  addFeature(feature) {
    const ref = firebaseRef.child('featureboard').push()
    const { title, description } = feature
    ref.set({
      title,
      description,
      author: {
        name: this.props.user.forumName,
        _id: this.props.user.id
      },
      votes: {
        [this.props.user.id]: true
      },
      _id: ref.key(),
      createdAt: Firebase.ServerValue.TIMESTAMP
    })
  }

  sortFeatures(a, b) {
    if (a.finished !== b.finished)
      return a.finished - (b.finished || false)
    return Object.keys(b.votes).length - Object.keys(a.votes).length
  }

  render() {
    return (
      <div className='col-xs-12 col-md-10 col-md-offset-1'>
        <ForumNameNotifier forumName={this.props.user.forumName} />
        <div className='panel'>
          <header className='panel-heading'>
            Requested features from the community
            <button className='btn btn-success pull-right' onClick={() => this.setState({showModal: true})} >REQUEST NEW FEATURE</button>
          </header>
          <div className='panel-body'>
            <FeatureBoard
              features={this.state.features.sort(this.sortFeatures)}
              userId={this.props.user.id}
            />
          </div>
        </div>
        <RequestFeatureModal
          show={this.state.showModal}
          onHide={() => this.setState({showModal: false})}
          onSubmit={this.addFeature.bind(this)}
        />
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/FeatureBoardContainer.js
 **/